<template>
    <td-dialog :title="$t(title)" :visible.sync="dialogOrgVisible" :before-close="orgDialogClose" :close-on-click-modal="false" :close-on-press-escape="false" width="290px" append-to-body>
        <td-tree
            :lazyloading="lazyloading"
            :height="height"
            :draggable="false"
            :isDbClick="isDbClick"
            :isClick="isClick"
            @getCheckedNodes="getCheckedNodes"
            :imgloading="true"
            ref="TdDialogTree"
            @onDbClick="onDbClickTree"
            @onClick="onClick"
            :checkStrictly="false"
            :checkNodes="checkNodes"
            :defaultProps="defaultProps"
            :nodeKey="nodeKey"
            :interfaceName="queryDeviceTree"
            :showBox="true"
            :calInternal="true"
            :isPaging="true"
            :params="params"
            :customProp="customProp"
        >
        </td-tree>
        <span slot="footer">
            <td-button type="primary" size="small" :loading="loading" @click="submitForm()">{{ $t('common.CONFIRM') }}</td-button>
            <td-button size="small" @click="orgDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: {
        title: {
            type: [String, String]
        },
        dialogOrgVisible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isDbClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        checkNodes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        height: {
            type: Number,
            default: function() {
                return 400;
            }
        },
        // 是否遵循父节点选中后子节点也相继选中
        checkStrictly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        lazyloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 设备类型
        deviceTypeList: {
            type: Array,
            default: function() {
                return null;
            }
        },
        width: {
            type: Number,
            default: function() {
                return 220;
            }
        }
    },
    mounted() {},
    data() {
        return {
            selectedNodes: [],
            loading: false,
            customProp: ['noPermission'],
            queryDeviceTree: { query: '/device/queryDeviceOrgTree', search: '/device/queryDeviceOrgTreeByName' },
            params: {
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                deviceTypeList: this.deviceTypeList
            },
            defaultProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            nodeKey: 'id'
        };
    },

    methods: {
        // 提交数据
        submitForm() {
            this.loading = true;
            this.selectedNodes = this.$refs.TdDialogTree.getCheckedNodes();
            this.$emit('selected', this.selectedNodes);
            this.$emit('submit');
            this.orgDialogClose();
        },
        // 关闭窗口之前需要调用的方法
        orgDialogClose() {
            this.$emit('orgDialogClose');
        },
        // 树形节点单击事件
        onClick(data) {
            this.clickData = data;
            if (this.isClick) {
                this.$emit('onClick', data);
            }
        },
        getCheckedNodes() {
            if (this.showBox) {
                let checkedNodes = this.$refs.TdDialogTree.getCheckedNodes();
                return checkedNodes;
            }
            return null;
        },
        onDbClickTree(data) {
            if (this.isDbClick) {
                this.$emit('onDbClickTree', data);
            }
        }
        // 单选框，复选框选中状态修改触发
        // checkChange(data, isCheck) {
        //     if (data.device) {
        //         this.$emit('checkChange', data, isCheck);
        //     } else {
        //         let node = this.$refs.TdDialogTree.getNode(data.id);
        //         node.setChecked(false);
        //         this.$message({ showClose: true, message: this.$t('pgError.ERROR_TREE_NODE_DEPT'), type: 'warning' });
        //     }
        // }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
</style>
